import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
// import { Modal } from "react-bootstrap";
import '../styles/form.css';
import axios from 'axios';
import { useRef } from 'react';
import "react-phone-input-2/lib/style.css";
import Select from "react-select";
import SourceModal from "../model/SourceModal"; // Import the modal component
import Flag from 'react-world-flags';
import { Commet } from "react-loading-indicators";



const CentralizedExportPortal = () => {
  const [formData, setFormData] = useState({
    sourceId: '',
    date: '',
    company: '',
    firstName: '',
    lastName: '',
    surname: '',
    country: '',
    contact: '',
    email: '',
    website: '',
    exportCountry: '',
    category: '',
    subcategory: '',
    comments: '',
    priority: '',
    emailType: '',
    datetime: new Date().toISOString(), // Set initial value to the current date/time
    businessCard: null,
    clientPicture: null
  });

  const formRef = useRef(null);
  const [newCategory, setNewCategory] = useState('');
  const [categories, setCategories] = useState([]);
  const [sources, setSources] = useState([]);
  const [showModal, setShowModal] = useState(false);
  // const [contact, setContact] = useState("");
  const [showSourceModal, setShowSourceModal] = useState(false);
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedExportCountry, setselectedExportCountry] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [showSubCategoryModal, setShowSubCategoryModal] = useState(false);
  const [newSubCategory, setNewSubCategory] = useState("");

  const api_url = process.env.REACT_APP_API_URL;



  // Fetch categories from API
  useEffect(() => {
    axios.get(`${api_url}/api/category`)
      .then((response) => {
        if (response.data && Array.isArray(response.data)) {
          setCategories(response.data); // Set fetched categories to state
        } else {
          console.error('Invalid category data received');
        }
      })
      .catch((error) => {
        console.error('Error fetching categories:', error);
      });
  }, [api_url]);

  // Fetch source from API
  useEffect(() => {
    axios.get(`${api_url}/api/source`)
      .then((response) => {
        if (response.data && Array.isArray(response.data)) {
          setSources(response.data); // Set fetched categories to state
        } else {
          console.error('Invalid source data received');
        }
      })
      .catch((error) => {
        console.error('Error fetching source:', error);
      });
  }, [api_url]);

  // Add new source to the state
  const addSource = (newSource) => {
    setSources((prevSources) => [
      ...prevSources,
      { SourceName: newSource }, // Add the new source to the sources array
    ]);
  };


  // Handle file change for Business Card upload (using scanner API)
  const handleBusinessCardUpload = async (e) => {
    const file = e.target.files[0];

    if (!file) {
      Swal.fire({
        icon: "warning",
        title: "No File Selected",
        text: "Please select a file before uploading.",
      });
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    const token = localStorage.getItem("token"); // Get JWT token

    try {
      setLoading(true); // Show loading effect

      const response = await fetch(`${api_url}/api/scanner`, {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`API Error: ${response.statusText}`);
      }

      const extractedData = await response.json();
      console.log("Extracted Data:", extractedData);

      // Get the first contact number (if exists)
      let firstContact = extractedData.contact?.split(",")[0]?.trim() || "";

      // Remove all non-numeric characters (special characters, spaces, dashes, etc.)
      firstContact = firstContact.replace(/\D/g, "");

      // Update form data
      setFormData((prev) => ({
        ...prev,
        company: extractedData.company || prev.company,
        firstName: extractedData.firstName || prev.firstName,
        lastName: extractedData.lastName || prev.lastName,
        email: extractedData.email || prev.email,
        website: extractedData.website || prev.website,
        contact: firstContact || prev.contact,
      }));

      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Business card data extracted successfully!",
      });
    } catch (error) {
      console.error("Error processing image:", error);
      Swal.fire({
        icon: "error",
        title: "Upload Failed",
        text: "Failed to process the image. Please try again.",
      });
    } finally {
      setLoading(false); // Hide loading effect
    }
  };

  // Handle QR Code upload and scanning
  const handleQRCodeUpload = async (e) => {
    const file = e.target.files[0];

    if (!file) {
      Swal.fire({
        icon: "warning",
        title: "No File Selected",
        text: "Please select a QR code image before uploading.",
      });
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    const token = localStorage.getItem("token"); // Get JWT token

    try {
      setLoading(true); // Show loading effect

      const response = await fetch(`${api_url}/api/qr-scanner`, {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`API Error: ${response.statusText}`);
      }

      const extractedData = await response.json();
      console.log("QR Code Extracted Data:", extractedData);

      // Get the first contact number (if exists)
      let firstContact = extractedData.contact?.split(",")[0]?.trim() || "";

      // Remove all non-numeric characters (special characters, spaces, dashes, etc.)
      firstContact = firstContact.replace(/\D/g, "");

      // Update form data
      setFormData((prev) => ({
        ...prev,
        company: extractedData.company || prev.company,
        firstName: extractedData.firstName || prev.firstName,
        lastName: extractedData.lastName || prev.lastName,
        email: extractedData.email || prev.email,
        website: extractedData.website || prev.website,
        contact: firstContact || prev.contact,
      }));

      Swal.fire({
        icon: "success",
        title: "Success",
        text: "QR code data extracted successfully!",
      });
    } catch (error) {
      console.error("Error processing QR code:", error);
      Swal.fire({
        icon: "error",
        title: "QR Code Processing Failed",
        text: "Failed to process the QR code. Please make sure it's a valid QR code image.",
      });
    } finally {
      setLoading(false); // Hide loading effect
    }
  };

  const fetchSubcategories = async (categoryId) => {
    if (!categoryId) return;
    try {
      await axios.get(`${api_url}/api/subcategories?CatID=${categoryId}`);
      // Subcategories are stored in selectedCategory.SubCategories, not in separate state
    } catch (error) {
      console.error("Error fetching subcategories:", error);
    }
  };

  const handleCategoryChange = (e) => {
    const categoryId = e.target.value;
    setFormData({ ...formData, category: categoryId });

    // Find the selected category by its ID
    const category = categories.find((cat) => cat.CategoryId === categoryId);
    setSelectedCategory(category); // Set selected category
  };

  const handleSubcategoryChange = (e) => {
    setFormData({ ...formData, subcategory: e.target.value });
  };


  const handleAddSubCategory = async () => {
    if (!newSubCategory.trim()) {
      // Alert if the subcategory name is empty
      Swal.fire({
        icon: 'warning',
        title: 'Oops...',
        text: 'Subcategory name cannot be empty!',
        confirmButtonText: 'Ok',
        confirmButtonColor: '#3085d6',
      });
      return;
    }

    if (!selectedCategory || !selectedCategory.CategoryId) {
      // Alert if no category is selected
      Swal.fire({
        icon: 'warning',
        title: 'Invalid Category',
        text: 'Please select a valid category first.',
        confirmButtonText: 'Ok',
        confirmButtonColor: '#3085d6',
      });
      return;
    }

    try {
      const response = await axios.post(`${api_url}/api/category/subcategories`, {
        CatID: selectedCategory.CategoryId, // Send only the CategoryId
        Sub_Categories: newSubCategory,
      });

      // Success alert
      Swal.fire({
        icon: 'success',
        title: 'Success!',
        text: response.data.message,
        confirmButtonText: 'Great!',
        confirmButtonColor: '#3085d6',
      });

      setNewSubCategory(""); // Clear the input field after submission
      fetchSubcategories(selectedCategory?.CategoryId); // Refresh subcategories
      setShowSubCategoryModal(false); // Close the modal
    } catch (error) {
      console.error("Error adding subcategory:", error);
      // Error alert
      Swal.fire({
        icon: 'error',
        title: 'Something went wrong!',
        text: 'Failed to add subcategory. Please try again.',
        confirmButtonText: 'Ok',
        confirmButtonColor: '#d33',
      });
    }
  };



  // Handle form input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };



  const getSriLankaTime = () => {
    const now = new Date();
    // Calculate the time offset for Sri Lanka (UTC+5:30)
    const sriLankaOffset = 5.5 * 60; // in minutes
    const utcOffset = now.getTimezoneOffset(); // in minutes
    const sriLankaTime = new Date(now.getTime() + (sriLankaOffset - utcOffset) * 60000);

    // Return the ISO string in Sri Lankan time
    return sriLankaTime.toISOString().slice(0, 19); // Exclude milliseconds and "Z"
  };

  // Handle file upload for client picture
  const handleClientPictureUpload = async (e) => {
    const file = e.target.files[0];

    if (!file) {
      Swal.fire({
        icon: "warning",
        title: "No File Selected",
        text: "Please select a file before uploading.",
      });
      return;
    }

    // Update the formData with clientPicture file
    setFormData((prev) => ({ ...prev, clientPicture: file }));
  };




  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if exportCountry is populated correctly
    // console.log("Form Data:", formData);

    // Check for required fields
    const requiredFields = ["sourceId", "date", "company", "firstName", "lastName", "contact", "email", "category", "priority", "emailType"];
    for (let field of requiredFields) {
      if (!formData[field]) {
        Swal.fire({
          icon: 'warning',
          title: 'Missing field',
          text: `Please fill out the ${field} field.`,
        });
        return;
      }
    }

    // Convert tradeFairDate to YYYY-MM-DD format
    const formattedTradeFairDate = new Date(formData.date).toISOString().split('T')[0];

    // Format datetime to match the format expected by the backend
    const currentDatetime = getSriLankaTime();

    const data = new FormData();
    data.append('sourceId', formData.sourceId);
    data.append('tradeFairDate', formattedTradeFairDate);
    data.append('companyName', formData.company);
    data.append('firstName', formData.firstName);
    data.append('lastName', formData.lastName);
    data.append('country', formData.country);
    data.append('contact', formData.contact);
    data.append('email', formData.email);
    data.append('website', formData.website);
    data.append('exportCountry', formData.exportCountry);
    data.append('categoryId', formData.category);
    data.append('subCategoryId', formData.subcategory);
    data.append('comments', formData.comments);
    data.append('priority', formData.priority);
    data.append('emailType', formData.emailType);
    // Append the current datetime to FormData
    data.append('datetime', currentDatetime);
    // data.append('status', 'New'); // Set the status to 'New' by default

    // Only append the files if they are selected
    // if (formData.businessCard) data.append('businessCard', formData.businessCard);
    if (formData.clientPicture) data.append('clientPicture', formData.clientPicture);

    // Log the FormData to console
    console.log("FormData being sent: ");
    for (let pair of data.entries()) {
      console.log(pair[0] + ": " + pair[1]);
    }

    // Get the token from localStorage
    const token = localStorage.getItem("token");


    try {
      const response = await axios.post(`${api_url}/api/vendor`, data, {
        headers: {
          "Content-Type": "multipart/form-data", // Ensure correct content type for files
          Authorization: `Bearer ${token}`, // Attach the token for authentication
        },
      });
      console.log("Response: ", response.data);

      // Success alert
      Swal.fire({
        icon: 'success',
        title: 'Success!',
        text: 'Form submitted successfully!',
      }).then(() => {
        // Reload the page after the success alert
        window.location.reload();
      });

    } catch (err) {
      console.error("Error response:", err.response);
      if (err.response) {
        console.error("Error details:", err.response.data); // Check for specific API error messages
      }

      // Error alert
      Swal.fire({
        icon: 'error',
        title: 'Oops!',
        text: 'An error occurred while submitting the form.',
      });
    }
  };


  // Add category to the database via the API
  const addCategory = () => {
    if (!newCategory) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Please enter a category name!',
      });
      return;
    }

    const categoryData = { Category: newCategory };

    axios.post(`${api_url}/api/category`, categoryData)
      .then((response) => {
        if (response.data) {
          Swal.fire({
            icon: 'success',
            title: 'Success!',
            text: 'Category added successfully.',
          }).then(() => {
            setShowModal(false);
            setNewCategory('');

            // Optionally, fetch updated categories after adding the new one
            axios.get(`${api_url}/api/category`)
              .then((res) => {
                setCategories(res.data);
              })
              .catch((error) => {
                console.error('Error fetching updated categories:', error);
              });
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Error adding category. Please try again.',
        });
        console.error('Error adding category:', error);
      });
  };



  useEffect(() => {
    fetch("https://restcountries.com/v3.1/all?fields=name,flags")
      .then((response) => response.json())
      .then((data) => {
        // Mapping and sorting the API response to include country name (label), code (value), and flag
        const countryOptions = data
          .map((country) => ({
            value: country.name.common, // Use the country code (ISO 3166-1 alpha-2)
            label: country.name.common, // Use the common name of the country
            flag: country.cca2, // Use the country code for the flag
          }))
          .sort((a, b) => a.label.localeCompare(b.label)); // Sort countries alphabetically by their common name
        setCountries(countryOptions);
      })
      .catch((error) => console.error("Error fetching countries:", error));
  }, []);

  const handleCountryChange = (selectedOption) => {
    setSelectedCountry(selectedOption);

    // Set the country name instead of the country code in form data
    setFormData((prevData) => ({
      ...prevData,
      country: selectedOption ? selectedOption.label : "", // Store the country name (label)
    }));
  };

  const handleExportCountryChange = (selectedOption) => {
    setselectedExportCountry(selectedOption);

    // Ensure selectedOption is an array before mapping
    const selectedCountryNames = selectedOption
      ? selectedOption.map(option => option.label).join(", ") // Extract labels and join with commas
      : ""; // If nothing is selected, set an empty string

    setFormData((prevData) => ({
      ...prevData,
      exportCountry: selectedCountryNames, // Assign the formatted string
    }));
  };


  return (
    <div className="container py-5">
      <h2 className="text-center mb-4">Centralized Export Portal</h2>

      <form ref={formRef} onSubmit={handleSubmit} className="p-4 border rounded shadow form-container">
        <div className="row">
          {/* Column 1 */}
          <div className="col-md-6">
            <div className="mb-3">
              <label htmlFor="source" className="form-label">Source / Trade Fair</label>
              <div className="input-group">
                <select
                  id="sourceId"
                  name="sourceId"
                  className="form-select"
                  value={formData.sourceId}
                  onChange={handleInputChange}
                >
                  <option value="" disabled>-- Select a source --</option>
                  {sources.length > 0 ? (
                    sources.map((source) => (
                      <option key={source.Id} value={source.Id}>{source.SourceName}</option>
                    ))
                  ) : (
                    <option disabled>No sources available</option>
                  )}
                </select>
                <button type="button" className="btn btn-primary" onClick={() => setShowSourceModal(true)}>
                  Add
                </button>
              </div>
            </div>

            <div className="mb-3">
              <label htmlFor="date" className="form-label">Date</label>
              <input
                type="date"
                id="date"
                name="date"
                className="form-control"
                required
                value={formData.date}
                onChange={handleInputChange}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="company" className="form-label">Company Name</label>
              <input
                type="text"
                id="company"
                name="company"
                className="form-control"
                placeholder="Enter company name"
                required
                value={formData.company}
                onChange={handleInputChange}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="firstName" className="form-label">First Name</label>
              <input
                type="text"
                id="firstName"
                name="firstName"
                className="form-control"
                placeholder="Enter first name"
                required
                value={formData.firstName}
                onChange={handleInputChange}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="lastName" className="form-label">Last Name</label>
              <input
                type="text"
                id="lastName"
                name="lastName"
                className="form-control"
                placeholder="Enter last name"
                required
                value={formData.lastName}
                onChange={handleInputChange}
              />
            </div>


            {/* the backend is not done for this */}

            <div className="mb-3">
              <label htmlFor="country" className="form-label">Country</label>
              <Select
                id="country"
                name="country"
                options={countries}
                value={selectedCountry}
                onChange={handleCountryChange}
                placeholder="Select a country"
                isClearable
                getOptionLabel={(e) => (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Flag code={e.flag} style={{ width: 20, marginRight: 10 }} />
                    {e.label}
                  </div>
                )}
              />
            </div>


            {/* <div className="mb-3">
              <label htmlFor="contact" className="form-label">
                Contact Number
              </label>
              <PhoneInput
                country={"us"} // Default country code

                value={formData.contact}
                onChange={handlePhoneChange}
                inputProps={{
                  name: "contact",
                  required: true,
                }}
              />
            </div> */}

            <div className="mb-3">
              <label htmlFor="contact" className="form-label">Contact Number</label>
              <input
                type="text"
                id="contact"
                name="contact"
                className="form-control"
                placeholder="Enter contact"
                required
                value={formData.contact}
                onChange={handleInputChange}
              />
            </div>


            <div className="mb-3">
              <label htmlFor="email" className="form-label">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                className="form-control"
                placeholder="Enter email"
                required
                value={formData.email}
                onChange={handleInputChange}
              />
            </div>

            {/* the backend is not done for this */}

            <div className="mb-3">
              <label htmlFor="email" className="form-label">Website</label>
              <input
                type="text"
                id="website"
                name="website"
                className="form-control"
                placeholder="Enter Website (e.g., https://example.com)"
                value={formData.website}
                onChange={handleInputChange}
              />
            </div>

          </div>

          {/* Column 2 */}
          <div className="col-md-6">

            {/* the backend is not done for this */}

            <div className="mb-3">
              <label htmlFor="exportCountry" className="form-label">Export Country</label>
              <Select
                id="exportCountry"
                name="exportCountry"
                options={countries}
                value={selectedExportCountry}  // Ensure the value is selectedExportCountry
                onChange={handleExportCountryChange}
                placeholder="Select export country"
                isMulti
                isClearable
                getOptionLabel={(e) => (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Flag code={e.flag} style={{ width: 20, marginRight: 10 }} />
                    {e.label}
                  </div>
                )}
                styles={{
                  control: (base) => ({
                    ...base,
                    zIndex: 2, // Ensures the select box appears above other elements
                  }),
                  menu: (base) => ({
                    ...base,
                    zIndex: 9999, // Ensure the dropdown menu appears above the button and everything else
                  }),
                }}
              />
            </div>

            <div>
              {/* Category Dropdown */}
              <div className="mb-3">
                <label htmlFor="category" className="form-label">Category</label>
                <div className="input-group">
                  <select
                    id="category"
                    name="category"
                    className="form-select"
                    value={formData.category}
                    onChange={handleCategoryChange}
                  >
                    <option value="" disabled>-- Select a category --</option>
                    {categories.length > 0 ? (
                      categories.map((category) => (
                        <option key={category.CategoryId} value={category.CategoryId}>
                          {category.Category}
                        </option>
                      ))
                    ) : (
                      <option disabled>No categories available</option>
                    )}
                  </select>
                  <button type="button" className="btn btn-primary" onClick={() => setShowModal(true)}>
                    Add
                  </button>
                </div>
              </div>

              {/* Subcategory Dropdown, always shown */}
              <div className="mb-3">
                <label htmlFor="subcategory" className="form-label">Subcategory</label>
                <div className="input-group">
                  <select
                    id="subcategory"
                    name="subcategory"
                    className="form-select"
                    value={formData.subcategory}
                    onChange={handleSubcategoryChange}
                  >
                    <option value="" disabled>-- Select a subcategory --</option>
                    {/* If the selected category has subcategories, show them */}
                    {selectedCategory && selectedCategory.SubCategories && selectedCategory.SubCategories !== 'null' ? (
                      selectedCategory.SubCategories.split(',').map((subCategory, index) => (
                        <option key={index} value={selectedCategory.SubCatIDs.split(',')[index]}>
                          {subCategory.trim()}
                        </option>
                      ))
                    ) : (
                      <option value="">No subcategories available</option>
                    )}
                  </select>
                  <button type="button" className="btn btn-primary" onClick={() => setShowSubCategoryModal(true)}>
                    Add
                  </button>
                </div>
              </div>
            </div>

            <div className="mb-3">
              <label htmlFor="comments" className="form-label">Comments/Remarks</label>
              <textarea
                id="comments"
                name="comments"
                className="form-control"
                rows="4"
                placeholder="Enter any comments or remarks"
                value={formData.comments}
                onChange={handleInputChange}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="priority" className="form-label">Priority Status</label>
              <select
                id="priority"
                name="priority"
                className="form-select"
                value={formData.priority}
                onChange={handleInputChange}
              >
                <option value="" disabled>-- Select priority status --</option>
                {['High', 'Medium', 'Low'].map((priority) => (
                  <option key={priority} value={priority}>{priority}</option>
                ))}
              </select>
            </div>


            {/* Floating Camera Button */}
            <label
              htmlFor="cameraInput"
              className="btn btn-primary floating-camera-btn d-flex align-items-center"
            >
              <i className="bi bi-camera" style={{ marginRight: "5px" }}></i>
            </label>

            <div className="mb-3">
              <label htmlFor="businessCard" className="form-label">Upload Business Card</label>
              <div className="input-group">
                {/* File Input for Business Card */}
                <input
                  type="file"
                  id="businessCard"
                  name="businessCard"
                  className="form-control"
                  accept=".jpg,.jpeg,.png,.pdf"
                  onChange={handleBusinessCardUpload}
                />

                {/* Camera Button for Business Card */}
                <label htmlFor="cameraInput" className="btn btn-primary d-flex align-items-center">
                  <i className="bi bi-camera" style={{ marginRight: '5px' }}></i>
                  Camera
                </label>

                {/* Hidden Camera Input for Business Card */}
                <input
                  type="file"
                  id="cameraInput"
                  name="cameraInput"
                  className="d-none" // Hide the file input element
                  accept="image/*"
                  capture="environment" // Open the device's camera
                  onChange={handleBusinessCardUpload}
                />
              </div>

              {loading && (
                <div className="fullscreen-loader">
                  <Commet color="#F68B1F" size="small" text="" textColor="" />
                </div>
              )}
            </div>

            {/* QR Code Scanning Section */}
            <div className="mb-3">
              <label htmlFor="qrCode" className="form-label">Scan QR Code</label>
              <div className="input-group">
                {/* File Input for QR Code */}
                <input
                  type="file"
                  id="qrCode"
                  name="qrCode"
                  className="form-control"
                  accept=".jpg,.jpeg,.png"
                  onChange={handleQRCodeUpload}
                />

                {/* Camera Button for QR Code */}
                <label htmlFor="qrCameraInput" className="btn btn-success d-flex align-items-center">
                  <i className="bi bi-qr-code-scan" style={{ marginRight: '5px' }}></i>
                  Scan QR
                </label>

                {/* Hidden Camera Input for QR Code */}
                <input
                  type="file"
                  id="qrCameraInput"
                  name="qrCameraInput"
                  className="d-none" // Hide the file input element
                  accept="image/*"
                  capture="environment" // Open the device's camera
                  onChange={handleQRCodeUpload}
                />
              </div>
              <small className="form-text text-muted">
                Upload a QR code image or use camera to scan QR codes containing contact information
              </small>
            </div>

            <div className="mb-3">
              <label htmlFor="clientPic" className="form-label">Picture of Client / Product</label>
              <input
                type="file"
                id="clientPicture"
                name="clientPicture"
                className="form-control"
                accept=".jpg,.jpeg,.png,.pdf"
                onChange={handleClientPictureUpload}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="emailType" className="form-label">Email Type</label>
              <select
                id="emailType"
                name="emailType"
                className="form-select"
                value={formData.emailType}
                onChange={handleInputChange}
              >
                <option value="" disabled>-- Select Email Type --</option>
                {['Common', 'Customized'].map((type) => (
                  <option key={type} value={type}>{type}</option>
                ))}
              </select>
            </div>

            <div className="mb-3">
              {/* <label htmlFor="datetime" className="form-label">Date/Time Tracking</label> */}
              <input
                type="hidden"
                id="datetime"
                name="datetime"
                className="form-control"
                value={formData.datetime}
                onChange={handleInputChange}
              />
            </div>

          </div>
        </div>

        <div className="d-flex justify-content-center">
          <button type="submit" className="btn btn-primary mt-4">Submit</button>
        </div>
      </form>

      {/* SubCategoryModal */}
      {showSubCategoryModal && (
        <div
          className="custom-modal-overlay"
          onClick={() => setShowSubCategoryModal(false)} // Close modal when clicking outside the content
        >
          <div
            className="custom-modal"
            onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the modal
          >
            <div className="custom-modal-header">
              <h5 className="custom-modal-title">Add Subcategory</h5>
              <button
                className="btn-close"
                onClick={() => setShowSubCategoryModal(false)}
              >
                &times;
              </button>
            </div>
            <div className="custom-modal-body">
              <input
                type="text"
                className="form-control"
                placeholder="Enter Subcategory Name"
                value={newSubCategory}
                onChange={(e) => setNewSubCategory(e.target.value)}
              />
            </div>
            <div className="custom-modal-footer">
              <button
                className="btn btn-secondary"
                onClick={() => setShowSubCategoryModal(false)}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={handleAddSubCategory}
              >
                Add Subcategory
              </button>
            </div>
          </div>
        </div>
      )}


      {/* Modal */}
      {showModal && (
        <div
          className="custom-modal-overlay"
          onClick={() => setShowModal(false)} // Close modal when clicking outside the content
        >
          <div
            className="custom-modal"
            onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the modal
          >
            <div className="custom-modal-header">
              <h5 className="custom-modal-title">Add New Category</h5>
              <button
                className="btn-close"
                onClick={() => setShowModal(false)}
              >
                &times;
              </button>
            </div>
            <div className="custom-modal-body">
              <input
                type="text"
                className="form-control"
                placeholder="Enter new category name"
                value={newCategory}
                onChange={(e) => setNewCategory(e.target.value)}
              />
            </div>
            <div className="custom-modal-footer">
              <button
                className="btn btn-secondary"
                onClick={() => setShowModal(false)}
              >
                Close
              </button>
              <button className="btn btn-primary" onClick={addCategory}>
                Add Category
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Source Modal */}
      {showSourceModal && (
        <SourceModal
          onClose={() => setShowSourceModal(false)}
          addSource={addSource} // Ensure you're passing addSource as a prop here
        />
      )}




    </div>
  );
};

export default CentralizedExportPortal;
